import { render, staticRenderFns } from "./IconPeople.vue?vue&type=template&id=51e6094d&scoped=true&"
import script from "./IconPeople.vue?vue&type=script&lang=js&"
export * from "./IconPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6094d",
  null
  
)

export default component.exports